import { css } from 'styled-components';

export default breakpoint => (...styles) => css`
  @media only screen and (max-width: ${breakpoint}px) {
    ${css(...styles)}
  }
`;
